<template>
  <div class="toast-container">
    <div class="content" v-html="text"></div>
  </div>
</template>

<script>
export default {
  created() {
    console.log('toast提示');
  },
  props: [
    'text'   // 这里是我们刚才创建vue实例传入的props
  ]
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 100000000001;
}
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 6px;
  padding: 8px;
  text-align: center;
  z-index: 100000000002;
}
</style>